export default {
    SUCESS : 200,
    BAD_REQUEST: 400,
    INTERNAL_SERVER_ERROR: 500
}